import type { GetApiV1ThreeLetterCodeClientAdminsUsersId200 } from '@fukuri-admins/apis/client/gen/model';
import type { EditUserFormValues } from '../schema';

type IConvertToFormValues = (
  data: GetApiV1ThreeLetterCodeClientAdminsUsersId200
) => EditUserFormValues;

/**
 * API レスポンスを利用者編集フォームの初期値に変換する
 *
 * - billable_from（'YYYY-MM-DD' 文字列）は Date に変換（DatePicker 用）
 * - branch.id は文字列化（Select の value）
 */
export const convertToFormValues: IConvertToFormValues = data => {
  const user = data.user;
  return {
    fullName: user.full_name,
    email: user.email,
    branchId: user.branch ? String(user.branch.id) : '',
    billableFrom: user.billable_from ? new Date(user.billable_from) : null,
  };
};
